import { render, staticRenderFns } from "./pharmacyPotentialList.vue?vue&type=template&id=3b85fefe&scoped=true"
import script from "./pharmacyPotentialList.vue?vue&type=script&lang=js"
export * from "./pharmacyPotentialList.vue?vue&type=script&lang=js"
import style0 from "./pharmacyPotentialList.vue?vue&type=style&index=0&id=3b85fefe&prod&scoped=true&lang=css"
import style1 from "./pharmacyPotentialList.vue?vue&type=style&index=1&id=3b85fefe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b85fefe",
  null
  
)

export default component.exports